import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth } from '../../context/AuthContext';
import { ROTULO_PERFIL, telaInicial } from '../../services/permissoes';

/** Tela mostrada quando o perfil do usuário não acessa a rota (padrão P-S1). */
export default function SemPermissao() {
  const navigate = useNavigate();
  const { acesso, perfilNome } = useAuth();
  const perfil = acesso?.perfil;
  return (
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
      <Paper variant="outlined" sx={{ p: 3, maxWidth: 420, textAlign: 'center' }} data-testid="sem-permissao">
        <LockOutlinedIcon color="action" sx={{ fontSize: 48, mb: 1 }} />
        <Typography variant="h6" gutterBottom>
          Sem permissão
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Seu perfil{perfil ? ` (${perfilNome || ROTULO_PERFIL[perfil] || perfil})` : ''} não tem acesso a esta tela. Se precisar dela,
          fale com o administrador da clínica.
        </Typography>
        <Button variant="contained" onClick={() => navigate(telaInicial(acesso), { replace: true })} sx={{ minHeight: 44 }}>
          Ir para a tela inicial
        </Button>
      </Paper>
    </Box>
  );
}
